import * as React from 'react';

const s = require('./seo_container.css');

export interface ISeoContainerProps {
  children ?: React.ReactNode;
}

export const SeoContainer = (props: ISeoContainerProps) => (
  <div className={s['c-seo']}>
    <div className="cg-container-fluid-xs">
      <div className="cg-row">
        {props.children}
      </div>
    </div>
  </div>
);
